import { useAuth } from "react-oidc-context";
import axios from "axios";
import { useMemo } from "react";

export const useApi = (baseURL) => {
  const auth = useAuth();

  const instance = useMemo(() => {
    const client = axios.create({ baseURL });

    client.interceptors.request.use(
      (config) => {
        const token = auth.user?.access_token;
        config.headers = config.headers || {};
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          };
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    client.interceptors.response.use(
      (res) => res,
      async (err) => {
        // If unauthorized, try to reinitiate login (OIDC) rather than redirect to My Cambridge homepage
        if (err.response?.status === 401) {
          // If OIDC is already loading/authing, just reject
          if (!auth.isLoading) {
            try {
              // Attempt a re-login flow; this will redirect to IdP if necessary
              await auth.signinRedirect();
            } catch (e) {
              console.error("signinRedirect failed:", e);
            }
          }
        }
        return Promise.reject(err);
      }
    );

    return client;
  }, [baseURL, auth.user, auth.isLoading, auth.signinRedirect]);

  return instance;
};